<template>
  <div class="container-fluid">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    >
    </loading>
    <div class="card-body col-sm-9 dropDownShipping">
      <multiselect
        class="form-control-sm form-control-select textarea"
        :placeholder="$t('buttons.selectAddress')"
        :value="selectedOption"
        :options="selectOptions"
        track-by="id"
        label="name"
        :searchable="true"
        deselectLabel=""
        selectLabel=""
        @input="selectShipment($event)"
      />
      <small class="font-italic font-weight-bolder ">{{
        $t("customer.selectShippingAddressToOrder")
      }}</small>
    </div>
    <div v-if="order.shipping.addressId" class="container-fluid ">
      <div class="row">
        <div class="col-lg-9 col-sm-9 col-12 ">
          <h5 class="card-title text-muted">
            <strong>{{ $t("products.addProducts") }}</strong>
          </h5>
        </div>
        <div class="col-lg-3 col-sm-3 col-12 ml-auto w-auto">
          <button
            class="float-right btn btn-theme-info btn-sm text-center ml-1 btn-block"
            @click="handleBackToCustomer"
          >
            {{ $t("buttons.returnClient") }}
          </button>
        </div>
        <search :term="searchTerm" @search="setSearchTerm" />
        <div class="col-md-12 ">
          <div class="table-responsive">
            <table class="table table-bordered table-striped p-2">
              <thead>
                <tr>
                  <th scope="col">
                    {{ $t("products.itemCode") }}
                  </th>
                  <th scope="col">
                    {{ $t("products.description") }}
                  </th>
                  <th scope="col">
                    {{ $t("products.price") }} "/"
                    {{ $t("products.priceAfterDiscount") }}
                  </th>
                  <th scope="col">
                    {{ $t("products.availableQuantity") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="p in processedProducts"
                  :key="p.id"
                  class="m-1 p-1 bg-light"
                  :class="{ topFive: handleTopFive(p) }"
                >
                  <td class="form-group">
                    <h6>{{ p.sku }}</h6>
                  </td>
                  <td class="">
                    <h6 v-if="p.url.length > 1">
                      <a target="_blank" :href="`${p.url}`">
                        {{ lang === "pl" ? p.name : p.descriptionEn }}
                      </a>
                    </h6>
                    <h6 v-else>
                      {{ lang === "pl" ? p.name : p.descriptionEn }}
                    </h6>
                  </td>
                  <td>
                    <span
                      class="badge badge-pill badge-primary float-left mb-3"
                    >
                      {{ currencyDisplay(p.price) }}
                    </span>
                    <span
                      class="badge badge-pill badge-success float-right mt-3"
                    >
                      {{
                        p.calculatedPrice > 0
                          ? currencyDisplay(p.calculatedPrice)
                          : currencyDisplay(p.price)
                      }}
                    </span>
                  </td>
                  <td>
                    {{
                      p.stock > "0" ? p.stock : 0
                    }}
                  </td>
                  <td colspan="3" class="text-center">
                    <div v-if="checkExistInBasket(p)">
                      <button
                        class="btn btn-success btn-sm text-center"
                        @click="handleProductAdd(p)"
                      >
                        {{ $t("buttons.add") }}
                      </button>
                    </div>
                    <div v-else>
                      <button class="btn btn-light btn-sm text-center">
                        {{ $t("buttons.added") }}
                      </button>
                    </div>
                    <!--                        <button class="btn btn-success btn-sm text-center" v-on:click="Global.data.">Add</button>-->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <page-controls
            :number-of-pages="pageCount"
            :current-page="currentPage"
            @pageChange="setCurrentPage"
            @sizeChange="setPageSize"
          />
        </div>
        <div class="col-12">
          <router-link to="/cart" class="btn btn-theme-add m-1 float-right">
            {{ $t("buttons.nextStep") }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import PageControls from "../../components/PageControls";
import Search from "../../components/Search";
import { currencyMixin } from "../../mixins";
import i18n from "../../translations";
import Multiselect from "vue-multiselect";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue from "vue";

export default {
  name: "ProductList",
  data() {
    return {
      isLoading: false,
      fullPage: true,
    };
  },
  components: { PageControls, Search, Multiselect, Loading },
  mixins: [currencyMixin],

  computed: {
    lang() {
      return i18n.locale;
    },
    ...mapGetters("products", ["processedProducts", "pageCount"]),
    ...mapGetters("cart", ["currentCustomer"]),
    ...mapState("products", ["currentPage", "products", "searchTerm"]),
    ...mapState("customers", ["customer"]),
    ...mapGetters("customers", {
      customerShipping: "shipping",
    }),
    ...mapState("cart", ["order"]),
    selectOptions() {
      return this.customerShipping
        ? this.customerShipping.map((shipObject) => ({
            name:
              shipObject.addressName +
              " - " +
              shipObject.city +
              " " +
              shipObject.street,
            id: shipObject.addressId,
          }))
        : [];
    },
    selectedOption() {
      return this.selectOptions.find(
        (el) => el.id === this.order.shipping.addressId
      );
    },
  },
  mounted() {
    if (!this.customerShipping) {
      this.getCurrentCustomer();
    }
  },

  methods: {
    ...mapActions("cart", ["addProduct", "backCustomer"]),
    ...mapActions("customers", ["getCurrentCustomer"]),
    ...mapActions("products", ["getProductsToCardCode"]),
    ...mapMutations("products", [
      "setCurrentPage",
      "setPageSize",
      "setSearchTerm",
    ]),
    ...mapMutations("cart", ["setCartData", "setShipping"]),
    handleProductAdd(product) {
      this.addProduct(product);
      Vue.notify({
        group: "success",
        title: this.$t("buttons.addToCart"),
        text: product.name + " " + product.sku,
      });
    },
    handleTopFive(product) {
      if (product.top === "true") return true;
      return false;
    },
    checkExistInBasket(product) {
      let findProduct = this.order.lines.find(
        (p) => p.product.id === product.id
      );
      if (findProduct) {
        return false;
      }
      return true;
    },
    selectShipment(value) {
      this.isLoading = true;
      this.setShipping(
        this.customerShipping.find(
          (shipObject) => shipObject.addressId === value.id
        )
      );
      this.$store.commit("cart/setCartData", []);
      localStorage.removeItem("cart");
      this.getProductsToCardCode().then((l) => {
        this.isLoading = false;
      });
    },
    clearProductsBasket() {
      this.setCartData([]);
      localStorage.removeItem("cart");
    },
    handleBackToCustomer() {
      let customer = JSON.parse(JSON.stringify(this.currentCustomer));
      if (Object.keys(customer).length > 0) {
        this.$router.push({
          name: "customer",
          params: {
            id: customer.cardCode,
          },
        });
      } else {
        this.$router.push("/customers");
      }
    },
  },
};
</script>
<style scoped>
.dropDownShipping {
  margin: auto;
  text-align: center;
}
.multiselect {
  border: 4px dotted #35495e;
}
</style>
